import {
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    useDisclosure
} from '@chakra-ui/react'
import GroupItem from '../../Groups/GroupItem'
import usePrintSalesItemsByWaiter from '../../hooks/usePrintSalesItemsByWaiter'
import ContentForm from './ContentForm'

export default function ModalSalesItemsByWaiters() {
    const { isLoading, submit } = usePrintSalesItemsByWaiter()
    const { isOpen, onClose, onOpen } = useDisclosure()

    return (
        <>
            <GroupItem
                onClick={onOpen}
                label="Ventas de Productos por Meser@"
            />
            <Modal isOpen={isOpen} onClose={onClose} size="sm">
                <ModalOverlay />
                <ModalContent p={4} pb={6}>
                    <ModalHeader textAlign="center">
                        Reporte de Ventas de Productos por Meser@
                    </ModalHeader>
                    <ModalBody>
                        <ContentForm onSubmit={submit} isLoading={isLoading} />
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    )
}
